// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.weekly-bills-planner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  font-family: Arial, sans-serif;
}

.weekly-bills-planner h1 {
  text-align: center;
  margin-bottom: 30px;
  color: #333;
}

/* Action buttons and inputs */
.planner-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  flex-wrap: wrap;
  gap: 15px;
}

.date-button {
  padding: 10px 15px;
  background-color: #4a90e2;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.date-button:hover {
  background-color: #357abd;
}

.file-upload {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.file-upload label {
  padding: 10px 15px;
  background-color: #5cb85c !important;
  color: white;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  margin-bottom: 5px;
  text-align: center;
}

.file-upload label:hover {
  background-color: #4cae4c !important;
}

.file-upload input[type="file"] {
  display: none;
}

.file-status {
  font-size: 12px;
  color: #777;
}

.payroll-input {
  display: flex;
  align-items: center;
}

.payroll-input label {
  margin-right: 10px;
  font-size: 14px;
}

.payroll-input input {
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  width: 150px;
}

/* Date dialog */
.date-dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
}

.dialog-content {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  width: 90%;
  max-width: 400px;
}

.dialog-content h3 {
  margin-top: 0;
  margin-bottom: 20px;
  text-align: center;
}

.dialog-content input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-bottom: 20px;
}

.dialog-buttons {
  display: flex;
  justify-content: space-between;
}

.dialog-buttons button {
  padding: 10px 15px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.dialog-buttons button:first-child {
  background-color: #ddd;
  color: #333;
}

.dialog-buttons button:last-child {
  background-color: #4a90e2;
  color: white;
}

.dialog-buttons button:last-child:disabled {
  background-color: #a9c7ec;
  cursor: not-allowed;
}

/* Content area */
.planner-content {
  margin-top: 30px;
}

.revenue-total {
  text-align: center;
  margin-bottom: 25px;
}

.revenue-total h2 {
  color: #333;
  font-size: 24px;
}

/* Weekly summary boxes */
.weekly-summary {
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
  flex-wrap: wrap;
  gap: 15px;
}

.summary-box {
  flex: 1 1;
  min-width: 150px;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.summary-box h3 {
  margin-top: 0;
  margin-bottom: 10px;
  font-size: 16px;
  color: #555;
}

.summary-box p {
  margin: 0;
  font-size: 20px;
  font-weight: bold;
  color: #333;
}

/* Daily boxes */
.daily-breakdown {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.day-box {
  border: 1px solid #ddd;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  min-width: 320px;
}

.day-header {
  background-color: #f5f5f5;
  padding: 10px 15px;
  border-bottom: 1px solid #ddd;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.day-header h3 {
  margin: 0;
  font-size: 16px;
  color: #333;
}

.day-header span {
  font-size: 14px;
  color: #777;
}

.day-content {
  padding: 15px;
}

.day-item {
  display: flex !important;
  justify-content: space-between;
  align-items: center;
  padding: 6px 0 !important;
  width: 100%;
  flex-wrap: wrap;
}

.day-item:last-child {
  margin-bottom: 0;
}

.day-item span:first-child {
  font-weight: bold;
  color: #555;
}

.day-item input {
  width: 120px;
  padding: 5px;
  border: 1px solid #ddd;
  border-radius: 4px;
  text-align: right;
}

.bills-list {
  width: 100%;
}

.bills-list div {
  flex-grow: 1;
  text-align: right;
  width: 100%;
}

.bills-list ul {
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
}

.bills-list li {
  padding: 4px 0;
  border-bottom: 1px dashed #eee;
}

.bills-list li:last-child {
  border-bottom: none;
}

.bills-total {
  font-weight: bold;
  margin-top: 5px;
  color: #333;
}

.left-over {
  font-weight: bold;
  margin-top: 15px;
  padding-top: 10px;
  border-top: 1px solid #ddd;
}

.left-over span:last-child {
  font-size: 16px;
  color: #4a90e2;
}

/* Print button */
.print-button {
  text-align: center;
  margin-top: 20px;
}

.print-button button {
  padding: 10px 20px;
  background-color: #4a90e2;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.print-button button:hover {
  background-color: #357abd;
}

/* Print-specific styles */
@media print {
  .planner-actions, .print-button, .day-item input, .dialog-content, .date-dialog {
    display: none !important;
  }
  
  .weekly-bills-planner {
    padding: 0;
  }
  
  .day-box {
    break-inside: avoid;
    page-break-inside: avoid;
    border: 1px solid #000;
  }
  
  .day-header {
    background-color: #eee !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
  
  .left-over span:last-child {
    color: #000 !important;
  }
  
  .summary-box {
    border: 1px solid #000;
  }
}

/* Debug button and panel */
.debug-button {
  padding: 10px 15px;
  background-color: #ff6b6b;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.debug-button:hover {
  background-color: #e05252;
}

.debug-panel {
  margin: 20px 0;
  padding: 15px;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 8px;
  overflow-x: auto;
}

.debug-panel h3 {
  margin-top: 0;
  margin-bottom: 15px;
  color: #333;
}

.debug-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.debug-table th,
.debug-table td {
  padding: 8px 12px;
  text-align: left;
  border-bottom: 1px solid #eee;
}

.debug-table th {
  background-color: #f5f5f5;
  font-weight: bold;
  color: #555;
}

.debug-table tr:nth-child(even) {
  background-color: #fafafa;
}

.debug-table tr:hover {
  background-color: #f0f8ff;
}

/* Hide debug in print mode */
@media print {
  .debug-button,
  .debug-panel {
    display: none !important;
  }
}

/* Week navigation */
.week-navigation {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.week-range {
  margin: 0;
  font-size: 22px;
  color: #333;
}

.nav-button {
  padding: 8px 15px;
  background-color: #4a90e2;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.nav-button:hover {
  background-color: #357abd;
}

/* Remove account balance section styles */
.account-balance-section,
.balance-input,
.balance-display,
.day-balance,
.balance-amount {
  display: none;
}

/* Add Bill button */
.add-bill-button {
  padding: 10px 15px;
  background-color: #5cb85c;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.add-bill-button:hover {
  background-color: #4cae4c;
}

/* Add bill form fields */
.form-field {
  margin-bottom: 15px;
}

.form-field label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
  color: #555;
}

.form-field input,
.form-field select {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

/* Bill item styling refinements */
.bill-item-content {
  display: flex;
  align-items: center;
  gap: 5px;
  flex: 1 1;
  min-width: 180px;
}

.bill-amount {
  cursor: pointer;
  padding: 2px 5px;
  border-radius: 3px;
  transition: background-color 0.2s;
  display: inline-block;
  margin-left: auto;
}

.bill-amount:hover {
  background-color: #f0f0f0;
}

.bill-actions {
  display: flex;
  gap: 5px;
  margin-left: 8px;
}

.bill-actions button {
  background: none;
  border: none;
  color: #4a90e2;
  cursor: pointer;
  font-size: 12px;
  padding: 2px 5px;
  border-radius: 3px;
}

.bill-actions button:hover {
  background-color: #f0f8ff;
}

.bill-actions button:last-child {
  color: #ff6b6b;
}

.bill-actions button:last-child:hover {
  background-color: #fff0f0;
}

/* Bill edit form */
.bill-edit-form {
  display: flex;
  align-items: center;
  gap: 5px;
}

.bill-edit-form input {
  width: 80px;
  padding: 2px 5px;
  border: 1px solid #ddd;
  border-radius: 3px;
  font-size: 14px;
}

.bill-edit-form button {
  background-color: #4a90e2;
  color: white;
  border: none;
  border-radius: 3px;
  padding: 2px 5px;
  font-size: 12px;
  cursor: pointer;
}

/* Move bill dialog improvements */
.move-bill-dialog {
  display: flex;
  gap: 5px;
  margin-top: 5px;
  padding: 5px;
  background-color: #f9f9f9;
  border-radius: 4px;
  border: 1px solid #eee;
  width: 100%;
  flex-wrap: wrap;
}

.move-bill-dialog select {
  flex: 1 1;
  padding: 3px;
  border: 1px solid #ddd;
  border-radius: 3px;
  font-size: 12px;
}

.move-bill-dialog button {
  border: none;
  border-radius: 3px;
  padding: 3px 8px;
  font-size: 12px;
  cursor: pointer;
}

.move-bill-dialog button:first-of-type {
  background-color: #4a90e2;
  color: white;
}

.move-bill-dialog button:last-of-type {
  background-color: #ddd;
  color: #333;
}

/* Debug table buttons */
.debug-table button {
  background-color: #ff6b6b;
  color: white;
  border: none;
  border-radius: 3px;
  padding: 3px 8px;
  font-size: 12px;
  cursor: pointer;
}

.debug-table button:hover {
  background-color: #e05252;
}

/* Print-specific styles for new elements */
@media print {
  .add-bill-button,
  .bill-actions,
  .bill-edit-form,
  .move-bill-dialog {
    display: none !important;
  }

  .bill-item {
    display: block !important;
  }
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .bill-item {
    flex-direction: column;
    align-items: flex-start;
    padding: 8px 0 !important;
  }
  
  .bill-item-content {
    width: 100%;
    margin-bottom: 5px;
  }
  
  .bill-actions {
    margin-left: auto;
  }
  
  .move-bill-dialog {
    margin-top: 8px;
  }

  .day-box {
    min-width: unset;
  }
}

/* Add Purchase button */
.add-purchase-button {
  padding: 10px 15px;
  background-color: #f0ad4e;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.add-purchase-button:hover {
  background-color: #ec971f;
}

/* Purchases list styling */
.purchases-list {
  width: 100%;
  margin-top: 15px;
  border-top: 1px dashed #eee;
  padding-top: 15px;
}

.purchases-list div {
  flex-grow: 1;
  text-align: right;
  width: 100%;
}

.purchases-list ul {
  list-style: none;
  padding: 0;
  margin: 0 0 10px 0;
  width: 100%;
}

.purchase-item {
  display: flex !important;
  justify-content: space-between;
  align-items: center;
  padding: 6px 0 !important;
  width: 100%;
}

.purchase-item-content {
  flex: 1 1;
}

.purchase-actions {
  display: flex;
  gap: 5px;
  margin-left: 8px;
}

.purchase-actions button {
  background: none;
  border: none;
  color: #ff6b6b;
  cursor: pointer;
  font-size: 12px;
  padding: 2px 5px;
  border-radius: 3px;
}

.purchase-actions button:hover {
  background-color: #fff0f0;
}

.purchases-total {
  font-weight: bold;
  margin-top: 5px;
  color: #333;
}

/* Add item button within day card */
.add-item-button {
  background: none;
  border: 1px dashed #ccc;
  width: 100%;
  padding: 5px;
  margin-top: 8px;
  color: #777;
  font-size: 12px;
  cursor: pointer;
  border-radius: 4px;
  text-align: center;
}

.add-item-button:hover {
  background-color: #f9f9f9;
  color: #333;
}

/* Weekly summary box for purchases */
.weekly-summary .summary-box:nth-child(5) {
  background-color: #fff9f0;
  border: 1px solid #ffe0b2;
}

/* Print-specific styles for new elements */
@media print {
  .add-purchase-button,
  .purchase-actions,
  .add-item-button {
    display: none !important;
  }

  .purchase-item {
    display: block !important;
  }
  
  .day-balance {
    border: 1px solid #000;
    background-color: #f8f8f8 !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
  
  .balance-amount {
    color: #000 !important;
  }
}

/* Manage Bills Button */
.manage-bills-button {
  padding: 10px 15px;
  background-color: #4a90e2;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.manage-bills-button:hover {
  background-color: #357abd;
}

/* Bills Manager Dialog */
.bills-manager-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.bills-manager-dialog {
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  width: 90%;
  max-width: 1000px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}

.bills-manager-header {
  padding: 20px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.bills-manager-header h2 {
  margin: 0;
  font-size: 24px;
  color: #333;
}

.close-button {
  background: none;
  border: none;
  font-size: 24px;
  color: #666;
  cursor: pointer;
  padding: 5px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.close-button:hover {
  background-color: #f5f5f5;
}

.bills-manager-content {
  padding: 20px;
  overflow-y: auto;
  flex: 1 1;
}

/* Bills Table */
.bills-table-container {
  overflow-x: auto;
}

.bills-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
}

.bills-table th,
.bills-table td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #eee;
}

.bills-table th {
  background-color: #f8f9fa;
  font-weight: 600;
  color: #333;
}

.bills-table tr:hover {
  background-color: #f8f9fa;
}

/* Edit Mode */
.edit-input {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.amount-input {
  display: flex;
  align-items: center;
  gap: 4px;
}

.amount-input span {
  color: #666;
}

.amount-input input {
  width: 100%;
}

/* Action Buttons */
.action-buttons {
  display: flex;
  gap: 8px;
  white-space: nowrap;
}

.edit-button,
.delete-button,
.save-button,
.cancel-button {
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.edit-button {
  background-color: #f8f9fa;
  color: #333;
}

.edit-button:hover {
  background-color: #e9ecef;
}

.delete-button {
  background-color: #fee2e2;
  color: #ef4444;
}

.delete-button:hover {
  background-color: #fecaca;
}

.save-button {
  background-color: #22c55e;
  color: white;
}

.save-button:hover {
  background-color: #16a34a;
}

.cancel-button {
  background-color: #f8f9fa;
  color: #333;
}

.cancel-button:hover {
  background-color: #e9ecef;
}

/* Add Bill Button */
.bills-manager-footer {
  padding: 20px;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: flex-end;
}

.add-bill-button {
  padding: 10px 20px;
  background-color: #3b82f6;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
}

.add-bill-button:hover {
  background-color: #2563eb;
}

/* Print styles */
@media print {
  .bills-manager-overlay {
    display: none !important;
  }
}

.planner-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  background-color: white;
  border-bottom: 1px solid #ddd;
  margin-bottom: 2rem;
}

.planner-header h1 {
  margin: 0;
}

.logout-button {
  padding: 10px 15px;
  background-color: #dc3545;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
}

.logout-button:hover {
  background-color: #c82333;
}

.week-view {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin: 20px;
}

.week-view h2 {
  margin-bottom: 20px;
  color: #333;
  font-size: 1.5em;
}

.days-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
  padding: 10px;
}

.day-card {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.day-header {
  border-bottom: 1px solid #dee2e6;
  margin-bottom: 15px;
  padding-bottom: 10px;
}

.day-header h3 {
  margin: 0;
  color: #495057;
  font-size: 1.2em;
}

.day-header p {
  margin: 5px 0 0;
  color: #6c757d;
  font-size: 0.9em;
}

.day-revenue {
  margin-bottom: 15px;
}

.day-revenue label {
  display: block;
  margin-bottom: 5px;
  color: #495057;
}

.input-with-symbol {
  display: flex;
  align-items: center;
  background: #fff;
  border: 1px solid #ced4da;
  border-radius: 4px;
  padding: 5px 10px;
}

.input-with-symbol span {
  color: #495057;
  margin-right: 5px;
}

.input-with-symbol input {
  border: none;
  outline: none;
  width: 100%;
  padding: 5px;
}

.day-purchases {
  margin-bottom: 15px;
}

.day-purchases h4 {
  margin: 0 0 10px;
  color: #495057;
}

.purchase-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
  background: #fff;
  border-radius: 4px;
  margin-bottom: 5px;
}

.purchase-item span {
  color: #495057;
}

.remove-button {
  background: none;
  border: none;
  color: #dc3545;
  cursor: pointer;
  font-size: 1.2em;
  padding: 0 5px;
}

.add-purchase-button {
  width: 100%;
  padding: 8px;
  background: #28a745;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 10px;
}

.add-purchase-button:hover {
  background: #218838;
}

.day-rates {
  margin-top: 15px;
}

.rate-item {
  margin-bottom: 10px;
}

.rate-item label {
  display: flex;
  align-items: center;
  color: #495057;
  margin-bottom: 5px;
}

.rate-item input[type="checkbox"] {
  margin-right: 8px;
}

.rate-item input[type="number"] {
  width: 80px;
  padding: 5px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  margin-left: 10px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .days-container {
    grid-template-columns: 1fr;
  }
  
  .day-card {
    margin-bottom: 15px;
  }
} `, "",{"version":3,"sources":["webpack://./src/styles/WeeklyBillsPlanner.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;AACd;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,yCAAyC;EACzC,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,WAAW;AACb;;AAEA;EACE,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,0BAA0B;AAC1B;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,wBAAwB;IACxB,sBAAsB;EACxB;;EAEA;IACE,iCAAiC;IACjC,iCAAiC;IACjC,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,6BAA6B;AAC7B;EACE;;IAEE,wBAAwB;EAC1B;AACF;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,0CAA0C;AAC1C;;;;;EAKE,aAAa;AACf;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA,wBAAwB;AACxB;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2CAA2C;AAC3C;EACE;;;;IAIE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,gBAAgB;EAChB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA,oCAAoC;AACpC;EACE,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA,qCAAqC;AACrC;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA,2CAA2C;AAC3C;EACE;;;IAGE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;IACtB,oCAAoC;IACpC,iCAAiC;IACjC,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,0CAA0C;EAC1C,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAO;AACT;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,cAAc;AACd;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;;;;EAIE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,0BAA0B;EAC1B,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;EACxC,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".weekly-bills-planner {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 20px;\n  font-family: Arial, sans-serif;\n}\n\n.weekly-bills-planner h1 {\n  text-align: center;\n  margin-bottom: 30px;\n  color: #333;\n}\n\n/* Action buttons and inputs */\n.planner-actions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n  flex-wrap: wrap;\n  gap: 15px;\n}\n\n.date-button {\n  padding: 10px 15px;\n  background-color: #4a90e2;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.date-button:hover {\n  background-color: #357abd;\n}\n\n.file-upload {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.file-upload label {\n  padding: 10px 15px;\n  background-color: #5cb85c !important;\n  color: white;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  margin-bottom: 5px;\n  text-align: center;\n}\n\n.file-upload label:hover {\n  background-color: #4cae4c !important;\n}\n\n.file-upload input[type=\"file\"] {\n  display: none;\n}\n\n.file-status {\n  font-size: 12px;\n  color: #777;\n}\n\n.payroll-input {\n  display: flex;\n  align-items: center;\n}\n\n.payroll-input label {\n  margin-right: 10px;\n  font-size: 14px;\n}\n\n.payroll-input input {\n  padding: 8px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  width: 150px;\n}\n\n/* Date dialog */\n.date-dialog {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 100;\n}\n\n.dialog-content {\n  background-color: white;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n  width: 90%;\n  max-width: 400px;\n}\n\n.dialog-content h3 {\n  margin-top: 0;\n  margin-bottom: 20px;\n  text-align: center;\n}\n\n.dialog-content input {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  margin-bottom: 20px;\n}\n\n.dialog-buttons {\n  display: flex;\n  justify-content: space-between;\n}\n\n.dialog-buttons button {\n  padding: 10px 15px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.dialog-buttons button:first-child {\n  background-color: #ddd;\n  color: #333;\n}\n\n.dialog-buttons button:last-child {\n  background-color: #4a90e2;\n  color: white;\n}\n\n.dialog-buttons button:last-child:disabled {\n  background-color: #a9c7ec;\n  cursor: not-allowed;\n}\n\n/* Content area */\n.planner-content {\n  margin-top: 30px;\n}\n\n.revenue-total {\n  text-align: center;\n  margin-bottom: 25px;\n}\n\n.revenue-total h2 {\n  color: #333;\n  font-size: 24px;\n}\n\n/* Weekly summary boxes */\n.weekly-summary {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 30px;\n  flex-wrap: wrap;\n  gap: 15px;\n}\n\n.summary-box {\n  flex: 1;\n  min-width: 150px;\n  padding: 15px;\n  border-radius: 8px;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n  text-align: center;\n}\n\n.summary-box h3 {\n  margin-top: 0;\n  margin-bottom: 10px;\n  font-size: 16px;\n  color: #555;\n}\n\n.summary-box p {\n  margin: 0;\n  font-size: 20px;\n  font-weight: bold;\n  color: #333;\n}\n\n/* Daily boxes */\n.daily-breakdown {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 20px;\n  margin-bottom: 30px;\n}\n\n.day-box {\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n  min-width: 320px;\n}\n\n.day-header {\n  background-color: #f5f5f5;\n  padding: 10px 15px;\n  border-bottom: 1px solid #ddd;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.day-header h3 {\n  margin: 0;\n  font-size: 16px;\n  color: #333;\n}\n\n.day-header span {\n  font-size: 14px;\n  color: #777;\n}\n\n.day-content {\n  padding: 15px;\n}\n\n.day-item {\n  display: flex !important;\n  justify-content: space-between;\n  align-items: center;\n  padding: 6px 0 !important;\n  width: 100%;\n  flex-wrap: wrap;\n}\n\n.day-item:last-child {\n  margin-bottom: 0;\n}\n\n.day-item span:first-child {\n  font-weight: bold;\n  color: #555;\n}\n\n.day-item input {\n  width: 120px;\n  padding: 5px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  text-align: right;\n}\n\n.bills-list {\n  width: 100%;\n}\n\n.bills-list div {\n  flex-grow: 1;\n  text-align: right;\n  width: 100%;\n}\n\n.bills-list ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  width: 100%;\n}\n\n.bills-list li {\n  padding: 4px 0;\n  border-bottom: 1px dashed #eee;\n}\n\n.bills-list li:last-child {\n  border-bottom: none;\n}\n\n.bills-total {\n  font-weight: bold;\n  margin-top: 5px;\n  color: #333;\n}\n\n.left-over {\n  font-weight: bold;\n  margin-top: 15px;\n  padding-top: 10px;\n  border-top: 1px solid #ddd;\n}\n\n.left-over span:last-child {\n  font-size: 16px;\n  color: #4a90e2;\n}\n\n/* Print button */\n.print-button {\n  text-align: center;\n  margin-top: 20px;\n}\n\n.print-button button {\n  padding: 10px 20px;\n  background-color: #4a90e2;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 16px;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.print-button button:hover {\n  background-color: #357abd;\n}\n\n/* Print-specific styles */\n@media print {\n  .planner-actions, .print-button, .day-item input, .dialog-content, .date-dialog {\n    display: none !important;\n  }\n  \n  .weekly-bills-planner {\n    padding: 0;\n  }\n  \n  .day-box {\n    break-inside: avoid;\n    page-break-inside: avoid;\n    border: 1px solid #000;\n  }\n  \n  .day-header {\n    background-color: #eee !important;\n    -webkit-print-color-adjust: exact;\n    print-color-adjust: exact;\n  }\n  \n  .left-over span:last-child {\n    color: #000 !important;\n  }\n  \n  .summary-box {\n    border: 1px solid #000;\n  }\n}\n\n/* Debug button and panel */\n.debug-button {\n  padding: 10px 15px;\n  background-color: #ff6b6b;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.debug-button:hover {\n  background-color: #e05252;\n}\n\n.debug-panel {\n  margin: 20px 0;\n  padding: 15px;\n  background-color: #f9f9f9;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  overflow-x: auto;\n}\n\n.debug-panel h3 {\n  margin-top: 0;\n  margin-bottom: 15px;\n  color: #333;\n}\n\n.debug-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n}\n\n.debug-table th,\n.debug-table td {\n  padding: 8px 12px;\n  text-align: left;\n  border-bottom: 1px solid #eee;\n}\n\n.debug-table th {\n  background-color: #f5f5f5;\n  font-weight: bold;\n  color: #555;\n}\n\n.debug-table tr:nth-child(even) {\n  background-color: #fafafa;\n}\n\n.debug-table tr:hover {\n  background-color: #f0f8ff;\n}\n\n/* Hide debug in print mode */\n@media print {\n  .debug-button,\n  .debug-panel {\n    display: none !important;\n  }\n}\n\n/* Week navigation */\n.week-navigation {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.week-range {\n  margin: 0;\n  font-size: 22px;\n  color: #333;\n}\n\n.nav-button {\n  padding: 8px 15px;\n  background-color: #4a90e2;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.nav-button:hover {\n  background-color: #357abd;\n}\n\n/* Remove account balance section styles */\n.account-balance-section,\n.balance-input,\n.balance-display,\n.day-balance,\n.balance-amount {\n  display: none;\n}\n\n/* Add Bill button */\n.add-bill-button {\n  padding: 10px 15px;\n  background-color: #5cb85c;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.add-bill-button:hover {\n  background-color: #4cae4c;\n}\n\n/* Add bill form fields */\n.form-field {\n  margin-bottom: 15px;\n}\n\n.form-field label {\n  display: block;\n  margin-bottom: 5px;\n  font-weight: bold;\n  color: #555;\n}\n\n.form-field input,\n.form-field select {\n  width: 100%;\n  padding: 8px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n/* Bill item styling refinements */\n.bill-item-content {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  flex: 1;\n  min-width: 180px;\n}\n\n.bill-amount {\n  cursor: pointer;\n  padding: 2px 5px;\n  border-radius: 3px;\n  transition: background-color 0.2s;\n  display: inline-block;\n  margin-left: auto;\n}\n\n.bill-amount:hover {\n  background-color: #f0f0f0;\n}\n\n.bill-actions {\n  display: flex;\n  gap: 5px;\n  margin-left: 8px;\n}\n\n.bill-actions button {\n  background: none;\n  border: none;\n  color: #4a90e2;\n  cursor: pointer;\n  font-size: 12px;\n  padding: 2px 5px;\n  border-radius: 3px;\n}\n\n.bill-actions button:hover {\n  background-color: #f0f8ff;\n}\n\n.bill-actions button:last-child {\n  color: #ff6b6b;\n}\n\n.bill-actions button:last-child:hover {\n  background-color: #fff0f0;\n}\n\n/* Bill edit form */\n.bill-edit-form {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.bill-edit-form input {\n  width: 80px;\n  padding: 2px 5px;\n  border: 1px solid #ddd;\n  border-radius: 3px;\n  font-size: 14px;\n}\n\n.bill-edit-form button {\n  background-color: #4a90e2;\n  color: white;\n  border: none;\n  border-radius: 3px;\n  padding: 2px 5px;\n  font-size: 12px;\n  cursor: pointer;\n}\n\n/* Move bill dialog improvements */\n.move-bill-dialog {\n  display: flex;\n  gap: 5px;\n  margin-top: 5px;\n  padding: 5px;\n  background-color: #f9f9f9;\n  border-radius: 4px;\n  border: 1px solid #eee;\n  width: 100%;\n  flex-wrap: wrap;\n}\n\n.move-bill-dialog select {\n  flex: 1;\n  padding: 3px;\n  border: 1px solid #ddd;\n  border-radius: 3px;\n  font-size: 12px;\n}\n\n.move-bill-dialog button {\n  border: none;\n  border-radius: 3px;\n  padding: 3px 8px;\n  font-size: 12px;\n  cursor: pointer;\n}\n\n.move-bill-dialog button:first-of-type {\n  background-color: #4a90e2;\n  color: white;\n}\n\n.move-bill-dialog button:last-of-type {\n  background-color: #ddd;\n  color: #333;\n}\n\n/* Debug table buttons */\n.debug-table button {\n  background-color: #ff6b6b;\n  color: white;\n  border: none;\n  border-radius: 3px;\n  padding: 3px 8px;\n  font-size: 12px;\n  cursor: pointer;\n}\n\n.debug-table button:hover {\n  background-color: #e05252;\n}\n\n/* Print-specific styles for new elements */\n@media print {\n  .add-bill-button,\n  .bill-actions,\n  .bill-edit-form,\n  .move-bill-dialog {\n    display: none !important;\n  }\n\n  .bill-item {\n    display: block !important;\n  }\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .bill-item {\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 8px 0 !important;\n  }\n  \n  .bill-item-content {\n    width: 100%;\n    margin-bottom: 5px;\n  }\n  \n  .bill-actions {\n    margin-left: auto;\n  }\n  \n  .move-bill-dialog {\n    margin-top: 8px;\n  }\n\n  .day-box {\n    min-width: unset;\n  }\n}\n\n/* Add Purchase button */\n.add-purchase-button {\n  padding: 10px 15px;\n  background-color: #f0ad4e;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.add-purchase-button:hover {\n  background-color: #ec971f;\n}\n\n/* Purchases list styling */\n.purchases-list {\n  width: 100%;\n  margin-top: 15px;\n  border-top: 1px dashed #eee;\n  padding-top: 15px;\n}\n\n.purchases-list div {\n  flex-grow: 1;\n  text-align: right;\n  width: 100%;\n}\n\n.purchases-list ul {\n  list-style: none;\n  padding: 0;\n  margin: 0 0 10px 0;\n  width: 100%;\n}\n\n.purchase-item {\n  display: flex !important;\n  justify-content: space-between;\n  align-items: center;\n  padding: 6px 0 !important;\n  width: 100%;\n}\n\n.purchase-item-content {\n  flex: 1;\n}\n\n.purchase-actions {\n  display: flex;\n  gap: 5px;\n  margin-left: 8px;\n}\n\n.purchase-actions button {\n  background: none;\n  border: none;\n  color: #ff6b6b;\n  cursor: pointer;\n  font-size: 12px;\n  padding: 2px 5px;\n  border-radius: 3px;\n}\n\n.purchase-actions button:hover {\n  background-color: #fff0f0;\n}\n\n.purchases-total {\n  font-weight: bold;\n  margin-top: 5px;\n  color: #333;\n}\n\n/* Add item button within day card */\n.add-item-button {\n  background: none;\n  border: 1px dashed #ccc;\n  width: 100%;\n  padding: 5px;\n  margin-top: 8px;\n  color: #777;\n  font-size: 12px;\n  cursor: pointer;\n  border-radius: 4px;\n  text-align: center;\n}\n\n.add-item-button:hover {\n  background-color: #f9f9f9;\n  color: #333;\n}\n\n/* Weekly summary box for purchases */\n.weekly-summary .summary-box:nth-child(5) {\n  background-color: #fff9f0;\n  border: 1px solid #ffe0b2;\n}\n\n/* Print-specific styles for new elements */\n@media print {\n  .add-purchase-button,\n  .purchase-actions,\n  .add-item-button {\n    display: none !important;\n  }\n\n  .purchase-item {\n    display: block !important;\n  }\n  \n  .day-balance {\n    border: 1px solid #000;\n    background-color: #f8f8f8 !important;\n    -webkit-print-color-adjust: exact;\n    print-color-adjust: exact;\n  }\n  \n  .balance-amount {\n    color: #000 !important;\n  }\n}\n\n/* Manage Bills Button */\n.manage-bills-button {\n  padding: 10px 15px;\n  background-color: #4a90e2;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.manage-bills-button:hover {\n  background-color: #357abd;\n}\n\n/* Bills Manager Dialog */\n.bills-manager-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.bills-manager-dialog {\n  background-color: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n  width: 90%;\n  max-width: 1000px;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.bills-manager-header {\n  padding: 20px;\n  border-bottom: 1px solid #eee;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.bills-manager-header h2 {\n  margin: 0;\n  font-size: 24px;\n  color: #333;\n}\n\n.close-button {\n  background: none;\n  border: none;\n  font-size: 24px;\n  color: #666;\n  cursor: pointer;\n  padding: 5px;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n}\n\n.close-button:hover {\n  background-color: #f5f5f5;\n}\n\n.bills-manager-content {\n  padding: 20px;\n  overflow-y: auto;\n  flex: 1;\n}\n\n/* Bills Table */\n.bills-table-container {\n  overflow-x: auto;\n}\n\n.bills-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-bottom: 20px;\n}\n\n.bills-table th,\n.bills-table td {\n  padding: 12px;\n  text-align: left;\n  border-bottom: 1px solid #eee;\n}\n\n.bills-table th {\n  background-color: #f8f9fa;\n  font-weight: 600;\n  color: #333;\n}\n\n.bills-table tr:hover {\n  background-color: #f8f9fa;\n}\n\n/* Edit Mode */\n.edit-input {\n  width: 100%;\n  padding: 8px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.amount-input {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.amount-input span {\n  color: #666;\n}\n\n.amount-input input {\n  width: 100%;\n}\n\n/* Action Buttons */\n.action-buttons {\n  display: flex;\n  gap: 8px;\n  white-space: nowrap;\n}\n\n.edit-button,\n.delete-button,\n.save-button,\n.cancel-button {\n  padding: 6px 12px;\n  border: none;\n  border-radius: 4px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.edit-button {\n  background-color: #f8f9fa;\n  color: #333;\n}\n\n.edit-button:hover {\n  background-color: #e9ecef;\n}\n\n.delete-button {\n  background-color: #fee2e2;\n  color: #ef4444;\n}\n\n.delete-button:hover {\n  background-color: #fecaca;\n}\n\n.save-button {\n  background-color: #22c55e;\n  color: white;\n}\n\n.save-button:hover {\n  background-color: #16a34a;\n}\n\n.cancel-button {\n  background-color: #f8f9fa;\n  color: #333;\n}\n\n.cancel-button:hover {\n  background-color: #e9ecef;\n}\n\n/* Add Bill Button */\n.bills-manager-footer {\n  padding: 20px;\n  border-top: 1px solid #eee;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.add-bill-button {\n  padding: 10px 20px;\n  background-color: #3b82f6;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.add-bill-button:hover {\n  background-color: #2563eb;\n}\n\n/* Print styles */\n@media print {\n  .bills-manager-overlay {\n    display: none !important;\n  }\n}\n\n.planner-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem 2rem;\n  background-color: white;\n  border-bottom: 1px solid #ddd;\n  margin-bottom: 2rem;\n}\n\n.planner-header h1 {\n  margin: 0;\n}\n\n.logout-button {\n  padding: 10px 15px;\n  background-color: #dc3545;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 1rem;\n}\n\n.logout-button:hover {\n  background-color: #c82333;\n}\n\n.week-view {\n  padding: 20px;\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  margin: 20px;\n}\n\n.week-view h2 {\n  margin-bottom: 20px;\n  color: #333;\n  font-size: 1.5em;\n}\n\n.days-container {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 20px;\n  padding: 10px;\n}\n\n.day-card {\n  background: #f8f9fa;\n  border-radius: 8px;\n  padding: 15px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.day-header {\n  border-bottom: 1px solid #dee2e6;\n  margin-bottom: 15px;\n  padding-bottom: 10px;\n}\n\n.day-header h3 {\n  margin: 0;\n  color: #495057;\n  font-size: 1.2em;\n}\n\n.day-header p {\n  margin: 5px 0 0;\n  color: #6c757d;\n  font-size: 0.9em;\n}\n\n.day-revenue {\n  margin-bottom: 15px;\n}\n\n.day-revenue label {\n  display: block;\n  margin-bottom: 5px;\n  color: #495057;\n}\n\n.input-with-symbol {\n  display: flex;\n  align-items: center;\n  background: #fff;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  padding: 5px 10px;\n}\n\n.input-with-symbol span {\n  color: #495057;\n  margin-right: 5px;\n}\n\n.input-with-symbol input {\n  border: none;\n  outline: none;\n  width: 100%;\n  padding: 5px;\n}\n\n.day-purchases {\n  margin-bottom: 15px;\n}\n\n.day-purchases h4 {\n  margin: 0 0 10px;\n  color: #495057;\n}\n\n.purchase-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px;\n  background: #fff;\n  border-radius: 4px;\n  margin-bottom: 5px;\n}\n\n.purchase-item span {\n  color: #495057;\n}\n\n.remove-button {\n  background: none;\n  border: none;\n  color: #dc3545;\n  cursor: pointer;\n  font-size: 1.2em;\n  padding: 0 5px;\n}\n\n.add-purchase-button {\n  width: 100%;\n  padding: 8px;\n  background: #28a745;\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-top: 10px;\n}\n\n.add-purchase-button:hover {\n  background: #218838;\n}\n\n.day-rates {\n  margin-top: 15px;\n}\n\n.rate-item {\n  margin-bottom: 10px;\n}\n\n.rate-item label {\n  display: flex;\n  align-items: center;\n  color: #495057;\n  margin-bottom: 5px;\n}\n\n.rate-item input[type=\"checkbox\"] {\n  margin-right: 8px;\n}\n\n.rate-item input[type=\"number\"] {\n  width: 80px;\n  padding: 5px;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  margin-left: 10px;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .days-container {\n    grid-template-columns: 1fr;\n  }\n  \n  .day-card {\n    margin-bottom: 15px;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
